module.exports = __webpack_public_path__ + "img/parents.c34132aa.png";